/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Jul 27 2023
 **/

import styled from "@emotion/styled";

import { Row } from "../../../Layouts";

export const ToastWrapper = styled(Row)<{ status: DesignStuff.Toast.Type }>`
	width: 480px;
	padding: 11px 20px;
	border-radius: 22px;
	word-break: break-all;
	background-color: ${({ status, theme }) => {
		switch (status) {
			case "system": {
				return theme.colors.neutral_70_100;
			}
			case "success": {
				return theme.colors.deco12_50_100;
			}
			case "info": {
				return theme.colors.deco8_50_100;
			}
			case "error": {
				return theme.colors.error_70_100;
			}
			case "fatal": {
				return theme.colors.error_90_100;
			}
		}
	}};
`;

export const ActionWrapper = styled(Row)`
	border-left: 1px solid ${({ theme }) => theme.colors.neutral_00_16};
	padding-left: 10px;
`;
